import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Target } from "@phosphor-icons/react";
import { API, setToken, setKind } from "@/lib/api";
import { CREATOR } from "@/constants/testIds";

export default function CreatorLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await axios.post(`${API}/auth/creator/login`, { email, password });
      setToken(r.data.access_token);
      setKind("creator");
      toast.success(`Welcome back, ${r.data.display_name}`);
      nav("/creator");
    } catch (err) {
      let d = err?.response?.data?.detail;
      if (Array.isArray(d)) d = d.map((x) => x?.msg || "").join(", ");
      else if (typeof d !== "string") d = null;
      toast.error(d || "Login failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="grain absolute inset-0 pointer-events-none" />
      <div className="w-full max-w-md relative">
        <Link to="/" className="kbd-label text-white/50 hover:text-neon-cyan">← BACK</Link>
        <div className="card-tactical p-8 mt-4">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 bg-neon-yellow flex items-center justify-center">
              <Target size={22} weight="bold" color="#050505" />
            </div>
            <div>
              <div className="kbd-label text-neon-yellow">CREATOR PORTAL</div>
              <h1 className="display-heading font-black text-2xl">Sign In</h1>
            </div>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <div className="kbd-label mb-2">EMAIL</div>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="creator-login-email"
                className="w-full bg-black/60 border border-white/10 px-4 py-3 font-mono text-sm focus:outline-none focus:border-neon-cyan"
                placeholder="you@example.com"
              />
            </div>
            <div>
              <div className="kbd-label mb-2">PASSWORD</div>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="creator-login-password"
                className="w-full bg-black/60 border border-white/10 px-4 py-3 font-mono text-sm focus:outline-none focus:border-neon-cyan"
                placeholder="••••••••••"
              />
            </div>
            <button
              type="submit"
              disabled={busy}
              data-testid={CREATOR.loginBtn}
              className="neon-btn w-full py-3 mt-2 disabled:opacity-50 inline-flex items-center justify-center gap-2"
            >
              {busy ? "SIGNING IN…" : "SIGN IN"}
            </button>
          </form>
          <div className="mt-4 text-center">
            <Link to="/creator/forgot-password" data-testid="creator-forgot-link" className="kbd-label text-white/50 hover:text-neon-cyan">
              FORGOT PASSWORD?
            </Link>
          </div>
          <p className="mt-6 kbd-label text-white/40">
            NO ACCOUNT? YOUR SERVER OWNER CREATES IT AND SHARES YOUR LOGIN.
          </p>
        </div>
      </div>
    </div>
  );
}
